export const LOGO_URL = "/assets/onchainlyfe-logo.png";

export const IMAGES = {
  btc: "https://images.pexels.com/photos/7267494/pexels-photo-7267494.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  eth: "https://images.pexels.com/photos/7767496/pexels-photo-7767496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  neon: "https://images.unsplash.com/photo-1780729995861-94f334dd55a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  neon2: "https://images.unsplash.com/photo-1780729996054-80dca2de1354?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sea: "https://images.pexels.com/photos/14337952/pexels-photo-14337952.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
